import type { AppRoute } from "@routes/types";
import { createElement } from "react";
import { LOGOUT_PATH } from "@routes/path";
import LogoutPage from "@pages/logout/Logout";

export const LogoutRoute: AppRoute[] = [
    {
       path: LOGOUT_PATH,
       label: "Logout",
       element: createElement(LogoutPage)
    }
]